// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__DDMD3","popup_show":"Popup_popup_show__eS7v0","popup__body":"Popup_popup__body__PGFVU"};